const actions = {
  
}

export default actions



// WEBPACK FOOTER //
// ./src/vuex/actions.js